import RegionItem from './RegionItem'
export default  RegionItem;